import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import PromiseContainer from '../../../components/data/PromiseContainer';
import { Page } from '../../../components/surfaces';
import { useStore } from '../../../store';
import usePromise from '../../../store/utils/usePromise';
import BundleForm from './components/BundleForm';

export default observer(function EditBundlePage() {
  const { bundleId = '' } = useParams();
  const { bundleStore } = useStore();

  const [bundlePromise] = usePromise(() =>
    bundleStore.fetchBundleAndProducts(bundleId),
  );

  return (
    <Page navigation={bundlePromise.value?.bundle?.displayName || '…'}>
      <PromiseContainer promise={bundlePromise}>
        {(value) => (
          <BundleForm bundle={value.bundle} products={value.products} />
        )}
      </PromiseContainer>
    </Page>
  );
});
